var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rightBanner.length > 0
    ? _c(
        "div",
        { staticClass: "right-banner-all" },
        _vm._l(_vm.rightBanner, function (banner) {
          return _c(
            "div",
            { key: banner.id, staticClass: "right-banner-item" },
            [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleBannerClick(
                        banner.contentId,
                        banner.contentType
                      )
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: banner.filePath, alt: "right-banner" },
                  }),
                ]
              ),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }